import React, { useEffect, useState } from 'react'
import { Button, Input, Select, TOAST_TYPE } from '@base'
import { Delete } from '@material-ui/icons'
import styled from 'styled-components'
import { useDispatch } from 'react-redux'
import { showToast } from '@data/state/action'
import { BiFieldWrapper } from './CategoryInfo'
import { Spacings } from '@styles'
import { toggleModal } from '@data/state/action/root'
import { MODAL_TYPES, strings } from '@constants'

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${Spacings.SPACING_2B};
`

const ListWrapper = styled.div`
	margin-top: ${Spacings.SPACING_2B};
`

const ListItem = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	background: ${({ theme }) => theme.palette.background.searchgrey};
	padding: ${Spacings.SPACING_2B} ${Spacings.SPACING_3B};
	border-radius: ${Spacings.SPACING_2B};
	margin-bottom: ${Spacings.SPACING_2B};
`

const Parameters = ({ formState, PARAMETERS = [], onChange }) => {
	const { parameters } = formState
	const dispatch = useDispatch()

	const [selectedKey, setSelectedKey] = useState(null)
	const [inputValue, setInputValue] = useState('')
	const [list, setList] = useState([])

	useEffect(() => {
		setList(parameters?.value)
	}, [parameters?.value])

	const addHandler = () => {
		if (!selectedKey || inputValue.trim() === '') return

		// duplicate check
		const alreadyExists = list?.filter((fil) => fil)?.some((item) => item.name === selectedKey?.name)

		if (alreadyExists) {
			dispatch(showToast(true, `${selectedKey.label} already added`, { type: TOAST_TYPE.ERROR }))
			return
		}

		const newItem = {
			name: selectedKey.name,
			value: inputValue,
		}

		const newList = list ? [...list, newItem] : [newItem]

		setList(newList)
		onChange?.(newList)

		setInputValue('')
		setSelectedKey(null)
	}

	const deleteHandler = (index) => {
		const newList = list.filter((_, i) => i !== index)

		setList(newList)
		onChange?.(newList)
	}

	const deleteConfirmHandler = (index) => {
		dispatch(
			toggleModal(true, MODAL_TYPES.CONFIRMATION, {
				overlayClickable: true,
				title: strings('msg_are_you_sure_want_to_delete'),
				confirmAction: (actionType) => {
					actionType && deleteHandler(index)
					dispatch(toggleModal(false))
				},
			})
		)
	}

	return (
		<Wrapper>
			<BiFieldWrapper isParameters>
				<Select
					id={parameters.id}
					label={parameters.label}
					placeholder={parameters?.placeholder}
					disabled={parameters.disabled}
					value={selectedKey || {}}
					required={parameters.required}
					primaryKey={parameters.primaryKey}
					displayKey={parameters.displayKey}
					data={PARAMETERS}
					onChange={setSelectedKey}
				/>
				<Input label={strings('enter', 'parameters')} placeholder='Enter value' value={inputValue} onChange={setInputValue} />

				<Button small disabled={!selectedKey || inputValue.trim() === ''} onClick={addHandler}>
					{strings('add')}
				</Button>
			</BiFieldWrapper>
			<ListWrapper>
				{list &&
					list
						?.filter((fil) => fil)
						?.map((item, index) => (
							<ListItem key={item.name}>
								<div>
									<strong>{PARAMETERS?.find((item2) => item2?.name === item?.name)?.label}</strong> : {item?.value}
								</div>

								<Button xs variant='destructive' onClick={() => deleteConfirmHandler(index)}>
									<Delete />
								</Button>
							</ListItem>
						))}
			</ListWrapper>
		</Wrapper>
	)
}

export default Parameters
